import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import FormDrawer from "components/__new/common/form-drawer";
import * as walletAction from "store/entities/wallet/action";
import { ButtonLoader } from "../common/form";


const UnfreezeAccount = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { unFreezeAccountLoading, unFreezeAccount, accountDetails } = useSelector((state) => state?.entities?.wallet);
    const {isOpen, setIsOpen} = props;

    const handleUnFreezeBusinessAccount = () => {
        const { walletId } = accountDetails?.data;

        dispatch(walletAction.unFreezeAccount(walletId));
    }

    useEffect(() => {
        // Redirect to all accounts on successful operation
        if (unFreezeAccount?.status === "success") {
            toast.success(unFreezeAccount?.message);
            setIsOpen(false);
            history.push('/account/all-accounts');
            dispatch(walletAction.resetUnFreezeAccount())
        }
    }, [unFreezeAccount, dispatch, history, setIsOpen]);

    return (
        <>
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="UnFreeze Account"
                        showCloseButton={true}
                        close={setIsOpen}
                    />

                    <div className="mt-4">
                        <div className="flex items-center text-[#4A5564] font-normal">
                            Are you sure you want to perform this action?
                        </div>
                    </div>

                    <div className="mt-4 bg-[#FEF5E7] p-3 rounded-2xl flex items-center">
                        <span>
                            Please note that you would be able to send and receive money on unfrozen account.
                        </span>
                    </div>

                    <div className="p-1 mt-4 flex items-center space-x-3">
                        <ButtonLoader loading={unFreezeAccountLoading} onClick={handleUnFreezeBusinessAccount} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                            Yes
                        </ButtonLoader>
                        <button type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                            onClick={() => setIsOpen(false)}
                            >
                                No
                        </button>
                    </div>
                </div>
            </FormDrawer>
        </>
    )
}


export default UnfreezeAccount;